import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../../pages/Sponsors';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import VideoBackground from '../../components/VideoBackground';
import { Link } from 'react-router-dom';

const FooterLayout: React.FC = ({ children }) => {
  return (<><div style={{ zIndex: -1 }}>
    <Particles
      params={{
        particles: {
          lineLinked: {
            enable: false,
            distance: 250,
            color: '#fff',
            width: 1,
            opacity: 1
          },
          move: {
            speed: 2,
            direction: 'right',
            collisions: false,
            outModes: {
              default: 'out',
              left: 'out',
              right: 'out',
              bottom: 'out',
              top: 'out',
            },


          },
          opacity: {
            value: 1,
            random: true,
            animation: {
              enable: false
            }

          },
          shape: {
            type: 'circle',
            polygon: {

              nb_sides: 6,

            },

          },

          color: { value: '#a69040', },

          number: {
            density: {
              enable: true,
              value_area: 2400,
            },
            value: 160,
          },
          size: {
            value: 8,
            random: true,
          },
        },
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: -1
      }}
    />
  </div>
    <div style={{ width: '100%', background: '#fff', padding: '50px 20px', zIndex: 10 }}>
      <Sponsors />
    </div>

  </>
  );
};

export default FooterLayout;
